<template>
  <section class="content">
    <div class="box">
      <div class="box-header with-border">
        <h3 class="box-title">Payment records</h3>
        <div class="box-tools pull-right">
          <v-btn @click="openAddDialog" small rounded color="secondary">
            <v-icon data-toggle="tooltip" data-placement="top" title="Submit a new Payment">add</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="box-body">
        <v-data-table
          :headers="headers"
          :items="records"
          class="elevation-1"
          data-app
        >
          <template v-slot:body="{items}">
            <tbody>
              <tr v-for="item in items" :key="item.name">
                <td>{{ campaignName(item.campaignID) }}</td>
                <td>$ {{ item.amount }}</td>
                <td>{{ item.createdAt | formatTime }}</td>
                <td>{{ item.status == 1 ? 'Approved' : 'Submitted' }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <!-- <div class="box-footer">
        footer
      </div> -->
    </div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <form>
        <v-card-title>
          <span class="headline">Submit a new Payment</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout column wrap>
              <v-flex xs12 sm6 md4>
                <v-select
                  :items="unpaidCampaigns" item-text="name" item-value="id"
                  label="Campaigns" prepend-icon="view_list"
                  required
                  v-model="addForm.campaignID"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Amount" type="number" hint="Insert the amount you need to submit (SGD)"
                  required
                  prepend-icon="attach_money"
                  v-model="addForm.amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  label="Attach Receipt/Proof"
                  prepend-icon='attach_file'
                  v-model="this.imageName"
                  @click="$refs.receipt.click()"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="receipt"
                  accept="image/*"
                  @change="prepareUpload"
                />
                <img
                  v-if="previewImage"
                  :src="previewImage"
                  width="100%"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1"
            text @click="add"
            :disabled="loadDialog"
            :loading="loadDialog"
          >Submit</v-btn>
        </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loadDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Submitting
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import clientAPIs from './clientAPIs';

export default {
  name: 'ViewClientPayments',
  data() {
    return {
      addForm: {
        campaignID: '',
        amount: 0,
        image: null
      },
      records: [],
      campaigns: [],
      unpaidCampaigns: [],
      headers: [
        {
          text: 'Campaign',
          value: 'campaignName'
        },
        {
          text: 'Amount',
          value: 'amount'
        },
        {
          text: 'Submitted Time',
          value: 'createdAt'
        },
        {
          text: 'Status',
          value: 'status'
        }
      ],
      dialog: false,
      previewImage: null,
      imageName: ' ',
      loadDialog: false
    }
  },
  created() {
    this.fetchClientCampaigns()
    this.fetchPaymentRecords()
    this.fetchAllCampaigns()
  },
  filters: {
    formatTime(value) {
      return moment(value).format('YYYY-MM-DD hh:mm:ss')
    }
  },
  methods: {
    fetchAllCampaigns() {
      // clientID will automatically assign in the server side
      clientAPIs
        .getCampaignsForClient({
          sort: 'updatedAt DESC'
        })
        .then(response => {
          let results = []
          response.campaigns.forEach(campaign => {
            let item = {
              id: campaign.id,
              name: campaign.name
            }
            results.push(item)
          })
          this.campaigns = results
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    campaignName(id) {
      const c = this.campaigns.find(c => c.id === id)
      return c ? c.name : ''
    },
    prepareUpload(e) {
      const img = e.target.files[0]
      this.addForm.image = img
      this.imageName = img.name
      const reader = new FileReader()
      reader.readAsDataURL(img)
      reader.onload = e => {
        this.previewImage = e.target.result
      }
    },
    add() {
      if (this.addForm.amount <= 0) {
        this.$swal({
          title: 'Please Enter a correct Amount',
          type: 'error'
        })
      } else if (this.addForm.image === null) {
        this.$swal({
          title: 'Please Attach a receipt of your payment',
          type: 'error'
        })
      } else {
        this.loadDialog = true
        let formData = new FormData()
        formData.append('image', this.addForm.image)
        formData.append('campaignID', this.addForm.campaignID)
        formData.append('amount', this.addForm.amount)
        api
          .request('post', '/api/v1/clients/payment-records', true, formData)
          .then(response => {
            if (response.status === 200) {
              this.loadDialog = false
              this.dialog = false
              this.addForm.amount = 0
              this.addForm.image = null
              this.fetchPaymentRecords()
            }
          })
          .catch(err => {
            this.loadDialog = false
            this.$swal({
              title: 'Error in submitting, please try again',
              type: 'error'
            })
            console.log(err)
          })
      }
    },
    fetchPaymentRecords() {
      api
        .request('get', '/api/v1/clients/payment-records', true)
        .then(response => {
          if (response.data.records) {
            this.records = response.data.records
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    fetchClientCampaigns() {
      api
        .request('get', '/api/v1/campaigns/client-campaigns', true)
        .then(response => {
          this.unpaidCampaigns = response.data.campaigns

          if (!this.addForm.campaignID && this.unpaidCampaigns.length > 0) {
            this.addForm.campaignID = this.unpaidCampaigns[0].id
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    openAddDialog() {
      if (this.unpaidCampaigns.length > 0) {
        this.dialog = true
      } else {
        this.$swal({
          title: 'You do not have any Campaigns to make payment',
          text: 'Please check back later',
          type: 'info'
        })
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Payment.vue?53d823b6